import { ProgressSpinner } from "primereact/progressspinner";
import { Message } from "primereact/message";
import { VenueForm } from "../../components/Forms/VenueForm";
import { useTenantScope } from "../../hooks/useTenantScope";
import { BenefitsMetricsTenantScopeHeader } from "../Reporting/components/BenefitsMetricsWidgets";

export const NewVenue = () => {
  const tenantScope = useTenantScope();
  const needsTenantSelection = !tenantScope.loading && !tenantScope.locked;

  return (
    <div className="grid">
      <div className="col-12">
        <div className="p-card p-4">
          <div className="flex align-items-center justify-content-center mb-2 pb-3 border-bottom-1 surface-border">
            <h2 className="text-2xl font-semibold text-900 m-0">Crear Venue</h2>
          </div>
          <BenefitsMetricsTenantScopeHeader tenantId={tenantScope.tenantId} />
          {tenantScope.loading ? (
            <div className="flex flex-column justify-content-center align-items-center p-5">
              <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" />
            </div>
          ) : needsTenantSelection ? (
            <Message
              severity="warn"
              className="w-full justify-content-start"
              text="Seleccioná un tenant en el selector superior para crear un venue"
            />
          ) : (
            <VenueForm />
          )}
        </div>
      </div>
    </div>
  );
};
